'use es6';

import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Text } from 'foundations-components/components/Text';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SidebarError() {
  return /*#__PURE__*/_jsx(ErrorMessage, {
    "data-test-id": "SidebarError",
    type: "403",
    illustration: "errors/general",
    illustrationProps: {
      width: 150
    },
    children: /*#__PURE__*/_jsx(Text, {
      paddingInline: "500",
      as: "p",
      children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "customerDataSidebar.sidebarError_jsx",
        options: {
          href: window.location.href
        },
        elements: {
          Link
        }
      })
    })
  });
}